import { render } from "./CourseAccess.vue?vue&type=template&id=572e503a&scoped=true"
import script from "./CourseAccess.vue?vue&type=script&lang=js"
export * from "./CourseAccess.vue?vue&type=script&lang=js"

import "./CourseAccess.vue?vue&type=style&index=0&id=572e503a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572e503a"]])

export default __exports__